export default __webpack_public_path__ + "d5e170b38b5a686bc886d136e53d2c38.mp3";